/**
 * Stores build information about <b>this specific version of the `ruffle-core` library</b>.
 *
 * It does not represent the version of Ruffle that may be in use by the page (for example, if a browser extension overrides it).
 *
 * @privateRemarks
 * This is generated at build time via `set_version.ts`.
 */
export const buildInfo = {
    versionNumber: "0.1.0",
    versionName: "0.1.0 nightly 2025-06-08",
    versionChannel: "nightly",
    buildDate: "2025-06-08T00:07:51.452Z",
    commitHash: "69cd5dcc34bf42376165b5647cdb66d5612776e8",
};
